import React from 'react';

import {
  doesToolHasMultipleGenerationModes,
  getTemplatesTitle,
  getToolDefaultGenerationMode,
  isBasicGenerationTool,
  GENERATION_TOOL,
} from 'src/data/generationTool';
import {
  getDefaultSuggestionModeLabel,
  getGuidanceDataFromGenerationResult,
  getRecomposeModeLabel,
  getSuggestionModeLabel,
  isGenerationGuidanceType,
  prepareGuidanceModeFullTitle,
  isSuggestGenerationResult,
  AI_SUGGESTION_MODE,
} from 'src/data/generation';
import { BaseItem } from '../BaseItem';

const getSuggestTitle = (generationData) => {
  const { suggestionAnnotationType, tovTitle, generationTool, suggestionMode, customFormulaName } =
    generationData;

  // If "guidance" mode was used
  if (isGenerationGuidanceType(suggestionAnnotationType)) {
    const guidanceData = getGuidanceDataFromGenerationResult(generationData);
    return prepareGuidanceModeFullTitle(guidanceData);
  }

  // if "custom formula" mode was used
  if (suggestionMode === AI_SUGGESTION_MODE.customFormula) {
    return customFormulaName;
  }

  // If "tone of voice" was used
  if (tovTitle) {
    return `${tovTitle} style`;
  }

  // If we have access to "generation tool", i.e. it's a new or properly migrated result
  if (generationTool) {
    const defaultMode = getToolDefaultGenerationMode(generationTool);
    const suggestionModeLabel = getSuggestionModeLabel(suggestionMode, generationTool);

    return suggestionMode === defaultMode
      ? getDefaultSuggestionModeLabel(generationTool)
      : suggestionModeLabel;
  }

  return getDefaultSuggestionModeLabel(generationTool);
};

const getRecomposeTitle = (generationData) => {
  const { recomposeMode, tovTitle, generationTool } = generationData;
  if (tovTitle) {
    return `${tovTitle} style`;
  }

  return getRecomposeModeLabel(recomposeMode, generationTool);
};

export const FrameworkItem = ({
  generationTool,
  requestData,
  vertical,
  multiline,
  baseItemClasses,
}) => {
  const isBasic = generationTool && isBasicGenerationTool(generationTool);
  const toolHasMultipleGenerationModes = doesToolHasMultipleGenerationModes(generationTool);

  if (
    (isBasic && !toolHasMultipleGenerationModes) ||
    generationTool === GENERATION_TOOL.basicContentImprover
  ) {
    return null;
  }

  const isSuggestion = isSuggestGenerationResult(requestData);
  const template = isSuggestion ? getSuggestTitle(requestData) : getRecomposeTitle(requestData);
  const baseItemLabel = getTemplatesTitle(generationTool);

  return (
    <BaseItem
      label={baseItemLabel}
      vertical={vertical}
      classes={baseItemClasses}
      hideTitleColon={multiline}
    >
      {template}
    </BaseItem>
  );
};
